import {
  Box, Checkbox, ListItem, Text,
} from '@domain-group/suit-theme'

import type { AttachmentTag } from '@models/types'

interface RequestedChangeProps {
  tag: AttachmentTag,
}

const RequestedChange = (props: RequestedChangeProps) => {
  const { tag: { comment, resolved } } = props

  return (
    <ListItem
      boxProps={{
        alignItems: 'center',
        as: 'a',
        borderBottom: '1px dashed',
        fontSize: 'small',
        padding: 'large',
      }}
      disableHover
    >
      <Checkbox
        checked={resolved}
        fontSize="small"
        style={{ cursor: 'default' }}
      />

      <Box alignItems="center" maxWidth="calc(100% - 30px)">
        <Box flexDirection="column" paddingRight="large">
          <Text lineHeight={1.3}>{comment}</Text>
        </Box>
      </Box>
    </ListItem>
  )
}

export default RequestedChange
